import { render, staticRenderFns } from "./LfHonor.vue?vue&type=template&id=6d5c242a&scoped=true&"
import script from "./LfHonor.vue?vue&type=script&lang=js&"
export * from "./LfHonor.vue?vue&type=script&lang=js&"
import style0 from "./LfHonor.vue?vue&type=style&index=0&id=6d5c242a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5c242a",
  null
  
)

export default component.exports